var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 22 24",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.10254 9.21034h19.60646",
    opacity: 0.4,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m5.26416 13.52c0-.4142.33579-.75.75-.75h.01019c.41421 0 .75.3358.75.75s-.33579.75-.75.75h-.01019c-.41421 0-.75-.3358-.75-.75zm5.64134-.75c-.4143 0-.75.3358-.75.75s.3357.75.75.75h.0101c.4143 0 .75-.3358.75-.75s-.3357-.75-.75-.75zm4.8815 0c-.4142 0-.75.3358-.75.75s.3358.75.75.75h.0102c.4142 0 .75-.3358.75-.75s-.3358-.75-.75-.75zm.0001 4.2904c-.4142 0-.75.3358-.75.75s.3358.75.75.75h.0102c.4142 0 .75-.3358.75-.75s-.3358-.75-.75-.75zm-5.6318.75c0-.4142.3358-.75.75-.75h.0102c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-.0102c-.4142 0-.75-.3358-.75-.75zm-4.14111-.75c-.41421 0-.75.3358-.75.75s.33579.75.75.75h.01019c.41422 0 .75-.3358.75-.75s-.33578-.75-.75-.75z",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.3479 1.0376v3.63219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.46216 1.0376v3.63219"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m15.5622 2.78076h-9.31412c-3.23037 0-5.24808 1.80566-5.24808 5.12473v9.98851c0 3.3713 2.01771 5.2187 5.24808 5.2187h9.30392c3.2405 0 5.2481-1.8161 5.2481-5.1352v-10.07201c.0101-3.31907-1.9974-5.12473-5.2379-5.12473z",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.7ff355b7.svg";
export { ForwardRef as ReactComponent };